import Categories from "../../components/categories/Categories";
import Posts from "../../components/posts/Posts";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./articles.css";
import { Link } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";

const Articles = ({ pgSize = 6, intro = false }) => {
  const [categoryTitle, setCategoryTitle] = useState("All Articles");
  const [page, setPage] = useState(1);
  const [pageSize] = useState(pgSize); // or any number you want
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("?");
  const location = useLocation();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const updateSearchAndTitle = async () => {
      const params = new URLSearchParams(location.search);
      const cat = params.get("cat");
      const author = params.get("author");
      const createdAt = params.get("createdAt");

      if (cat) {
        setSearch(`?filters[categories][documentId][$eq]=${cat}&`);
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/categories?filters[documentId][$eq]=${cat}`,
            // {
            //   headers: {
            //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
            //   },
            // }
          );
          const name = res.data.data[0]?.name + " Articles" || "All Articles";
          setCategoryTitle(name);
        } catch (err) {
          setCategoryTitle("Category");
        }
      } else if (author) {
        setSearch(`?filters[author][documentId][$eq]=${author}&`);
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/authors?filters[documentId][$eq]=${author}`,
            // {
            //   headers: {
            //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
            //   },
            // }
          );

          const name = res.data.data[0]?.name || "Author";
          setCategoryTitle(`Posts by ${name}`);
        } catch (err) {
          setCategoryTitle("Author");
        }
      } else if (createdAt) {
        const date = new Date(createdAt).toDateString();
        const dateRange = {
          zeroHour: "T00:00:00.000Z",
          lastHour: "T23:59:59.999Z",
        };
        setSearch(
          `?filters[createdAt][$gte]=${createdAt.split("T")[0]}${
            dateRange.zeroHour
          }&filters[createdAt][$lte]=${createdAt.split("T")[0]}${
            dateRange.lastHour
          }&`,
        );
        setCategoryTitle(`Posts from ${date}`);
      } else {
        setSearch("?");
        setCategoryTitle("All Articles");
      }
    };

    updateSearchAndTitle();
  }, [location.search]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/posts${search}pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate[photo]=true&populate[categories]=true&sort=createdAt:desc`,
          // {
          //   headers: {
          //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
          //   },
          // }
        );
        setPosts(res.data.data);
        setTotalPages(res.data.meta.pagination.pageCount); // ← Add this
      } catch (error) {
        console.log(error);
      }
    };
    fetchPosts();
  }, [search, page, pageSize]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  return (
    <div className={!intro ? `d-flex flex-column flex-lg-row` : ``}>
      <div className="postsContainer">
        <div
          className={`d-flex flex-column w-100 justify-content-center align-items-center`}
        >
          {intro ? <h2>{categoryTitle}</h2> : <h1>{categoryTitle}</h1>}
          {!intro && <Categories />}

          <Posts posts={posts} />
          <div className="pagination">
            <button
              disabled={page <= 1}
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            >
              <i className="fa-solid fa-angle-left"></i>
            </button>

            <p className="text-center text-wrap">
              {page} of {totalPages}
            </p>

            <button
              disabled={page >= totalPages}
              onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            >
              <i className="fa-solid fa-angle-right"></i>
            </button>
          </div>

          {intro && (
            <Link to="/articles">
              <button className="mb-4" type="button">
                View all Articles
              </button>
            </Link>
          )}
        </div>
      </div>
      {!intro && <Sidebar withGallery={false} />}
    </div>
  );
};

export default Articles;
